"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var tyrande_1 = require("tyrande");
var url_1 = require("../../utils/url");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var admin_1 = require("services/page/admin");
var ssrcontext_1 = require("../../ssrcontext");
var channelTypes = (_a = {},
    _a[admin_1.TModuleType.TNavIcons] = tyrande_1.ComponentType.Navigation,
    _a[admin_1.TModuleType.TQuickNav] = tyrande_1.ComponentType.Navigation,
    _a[admin_1.TModuleType.TBanner] = tyrande_1.ComponentType.Banner,
    _a[admin_1.TModuleType.TSwiper] = tyrande_1.ComponentType.Banner,
    _a[admin_1.TModuleType.TMagicBannerType] = tyrande_1.ComponentType.MagicBanner,
    _a[admin_1.TModuleType.TMagicBannerTwo] = tyrande_1.ComponentType.MagicBannerTwo,
    _a.FlashProductWithTag = tyrande_1.ComponentType.FlashProductWithTag,
    _a.FlashProduct = tyrande_1.ComponentType.FlashProduct,
    _a.ProductWithTag = tyrande_1.ComponentType.ProductWithTag,
    _a.Product = tyrande_1.ComponentType.Product,
    _a[admin_1.TModuleType.TEvent] = tyrande_1.ComponentType.Event,
    _a[admin_1.TModuleType.TCoupon] = tyrande_1.ComponentType.Coupon,
    _a);
function WithEZSpm(WrapperComponent) {
    return function (dataFromServer) {
        var spm = {
            site: isomorphismConstant_1.default.siteCode || 1,
            pageId: ssrcontext_1.runInServer()
                ? ssrcontext_1.getSnapshootByKey("id")
                : url_1.getSearchParamValue("id") || dataFromServer.pageId,
            activityId: dataFromServer.activityId,
            componentType: channelTypes[dataFromServer.componentType] || "--",
            index: dataFromServer.index,
            moduleId: dataFromServer.moduleId,
            position: dataFromServer.id
        };
        var spmExtraInfo = {};
        return (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                return _super.call(this, props) || this;
            }
            class_1.prototype.render = function () {
                return React.createElement(WrapperComponent, __assign({ spm: __assign({}, spm), spmExtraInfo: spmExtraInfo }, this.props));
            };
            return class_1;
        }(React.Component));
    };
}
exports.default = WithEZSpm;
